import { SELECIONAR_RESERVA_REEMBOLSO_SOLICITADO } from '../../actions/types'

const initialState = {}

export default function reducerSelecionaReservaReembolsoSolicitado (state = initialState, action) {
  switch (action.type) {
    case SELECIONAR_RESERVA_REEMBOLSO_SOLICITADO: {
        if (!action.payload) {
            return {};
        }
      return action.payload;
    }

    default: {
      return state
    }
  }
}